import { JSX } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthProvider';
import AccountTrialBalance from '../pages/protected/reports/rpt-act-trial-balance';
import { PurchaseOrderForm } from '../pages/protected/purchase-order/purchase-order-form';
import { Logout } from '../pages/auth/Logout';
import Login from '../pages/auth/Login';
import { baseURL } from '../constants/config';
import AuthLayout from '../layouts/auth-layout';
import ProtectedLayout from '../layouts/protected-layout';
import Dashboard from '../pages/protected/dashboard';
import PurchaseOrderList from '../pages/protected/purchase-order/purchase-order-list';
import Page404 from '../components/Page404';
import ItemList from '../pages/protected/items/item-list';
import BrandList from '../pages/protected/brands/brand-list';
import ColorList from '../pages/protected/colors/color-list';
import PurchaseOrderItemBalance from '../pages/protected/reports/rpt-po-pi-item-balance';
import SaleOrderList from '../pages/protected/sale-order/sale-order-list';
import { SaleOrderForm } from '../pages/protected/sale-order/sale-order-form';
import SaleOrderItemBalance from '../pages/protected/reports/rpt-so-si-item-balance';
import AgentAccountTrialBalance from '../pages/protected/reports/rpt-agt-act-trial-balance';
import { RoutesEnum } from './routes.enum';

export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
 const { authInfo } = useAuth();
 if (!authInfo?.authenticated) {
  return <Navigate to={`${baseURL}auth/login`} replace />;
 }
 return <ProtectedLayout>{children}</ProtectedLayout>;
};

export const AuthRoute = ({ children }: { children: JSX.Element }) => {
 const { authInfo } = useAuth();
 if (authInfo?.authenticated) {
  return <Navigate to={`${baseURL}dashboard`} replace />;
 }
 return <AuthLayout>{children}</AuthLayout>;
};

const AppRoutes = () => {
 const { authInfo } = useAuth();
 const protectedRoutes = [
  { component: Dashboard, path: RoutesEnum.Dashboard },

  { component: ItemList, path: RoutesEnum.ItemList },
  { component: BrandList, path: RoutesEnum.BrandList },
  { component: ColorList, path: RoutesEnum.ColorList },

  { component: PurchaseOrderList, path: RoutesEnum.PurchaseOrderList },
  { component: PurchaseOrderForm, path: `${RoutesEnum.PurchaseOrderForm}/add` },
  { component: PurchaseOrderForm, path: `${RoutesEnum.PurchaseOrderForm}/edit/:id` },

  { component: SaleOrderList, path: RoutesEnum.SaleOrderList },
  { component: SaleOrderForm, path: `${RoutesEnum.SaleOrderForm}/add` },
  { component: SaleOrderForm, path: `${RoutesEnum.SaleOrderForm}/edit/:id` },

  { component: AccountTrialBalance, path: RoutesEnum.AccountTrialBalance },
  { component: AgentAccountTrialBalance, path: RoutesEnum.AgentAccountTrialBalance },
  { component: PurchaseOrderItemBalance, path: RoutesEnum.PurchaseOrderItemBalance },
  { component: SaleOrderItemBalance, path: RoutesEnum.SaleOrderItemBalance },

  { component: Logout, path: RoutesEnum.Logout },
 ];
 const authRoutes = [
  { component: Login, path: RoutesEnum.Login },
 ];

 return (
  <BrowserRouter>
   <Routes>
    {protectedRoutes.map((prop, index) => {
     const Component = prop.component;
     return (
      <Route
       key={index}
       path={`${baseURL}${prop.path}`}
       element={
        <ProtectedRoute>
         <Component />
        </ProtectedRoute>
       }
      />
     );
    })}

    {authRoutes.map((prop, index) => {
     const Component = prop.component;
     return (
      <Route
       key={index}
       path={`${baseURL}${prop.path}`}
       element={
        <AuthRoute>
         <Component />
        </AuthRoute>
       }
      />
     );
    })}
    <Route
     path={baseURL}
     element={
      <Navigate
       to={`${baseURL}${authInfo?.authenticated ? RoutesEnum.Dashboard : RoutesEnum.Login}`}
       replace
      />
     }
    />
    <Route path="*" element={<Page404 />} />
   </Routes>
  </BrowserRouter>
 );
};

export default AppRoutes;